import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/** What a page is for when it has nothing to show yet, with its primary action. */
export function EmptyState({
  title,
  children,
  action,
  testId,
}: {
  title: string;
  children?: React.ReactNode;
  action?: React.ReactNode;
  testId?: string;
}) {
  return (
    <Paper
      variant="outlined"
      sx={{ p: { xs: 3, sm: 5 }, textAlign: 'center' }}
      data-testid={testId}
    >
      <Stack spacing={1.5} sx={{ alignItems: 'center' }}>
        <Typography variant="h6" component="h2">
          {title}
        </Typography>
        {children && (
          <Typography color="text.secondary" sx={{ maxWidth: 480 }}>
            {children}
          </Typography>
        )}
        {action}
      </Stack>
    </Paper>
  );
}
